module.exports = __webpack_public_path__ + "static/img/verve.612a796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/verve.png
// module id = qkK1
// module chunks = 1